import { useMutation } from '@tanstack/react-query';
import { submitOrder } from '@services/cpqService';
import { useSessionContext } from '@contexts/SessionContext';

interface UseSubmitOrderOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
}

export const useSubmitOrder = (sessionId: string, { onSuccess, onError }: UseSubmitOrderOptions = {}) => {
  const { clearSession } = useSessionContext();

  const mutation = useMutation<unknown, Error, void>({
    mutationFn: () => submitOrder(sessionId),
    onSuccess: (data) => {
      // Order completed — clear session so a fresh one is created next time
      clearSession();
      onSuccess?.(data);
    },
    onError,
  });

  return {
    submit: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
